module.exports = __webpack_public_path__ + "static/media/program-antyplagiatowy-wrona-2.8f27cfcc.webp";